// extracted by mini-css-extract-plugin
module.exports = {"header":"Application_header__1EZln","subHeader":"Application_subHeader__1feme"};